import React from 'react';
import { VegobjekttypeState, VegobjekttypeCategoryState } from '@/state';
import {
    VegobjekterResult,
    VegobjekterStatistic,
} from '@/domain/vegobjekter/VegobjekterResult';
import { defaultColor, resolveColor } from '@/utils/ColorHelper';
import { Omradeantall } from './Omradeantall';

interface AreaCountersProps {
    roadObjectTypes: VegobjekttypeState[];
}

type VegobjekttypeStateWithAreaResult = VegobjekttypeState & {
    typeId: number;
    result: VegobjekterResult;
};

type VegobjekterStatisticWithOmrade = VegobjekterStatistic & {
    omrade: NonNullable<VegobjekterStatistic['omrade']>;
};

type AreaCountProps = {
    antall: number;
    omrade: VegobjekterStatisticWithOmrade['omrade'];
    colorString: string;
    vegobjektTypeId: number;
    visible: boolean;
};

const AreaCountComponent = Omradeantall as unknown as React.ComponentType<AreaCountProps>;

const hasAreaStatistics = (
    featureType: VegobjekttypeState
): featureType is VegobjekttypeStateWithAreaResult => {
    const result = featureType.result;
    return (
        featureType.typeId !== null &&
        result !== null &&
        ((result.extentStatistics?.antall ?? 0) <= 0 || result.vegobjekter.length <= 0)
    );
};

const hasOmrade = (
    statistic: VegobjekterStatistic
): statistic is VegobjekterStatisticWithOmrade => statistic.omrade != null;

export const AreaStatisticsLayer: React.FC<AreaCountersProps> = ({ roadObjectTypes }) => {
    const areaCountElement = (
        rot: VegobjekttypeStateWithAreaResult,
        s: VegobjekterStatisticWithOmrade,
        colorString: string,
        cat: VegobjekttypeCategoryState | null = null,
        catIndex: number | null = null
    ) => {
        const rotCategoryKey = `${rot.typeId}${!!catIndex ? '-i' + catIndex : ''}`;
        const componentKey = `${rotCategoryKey}-${s.omrade}`;
        return React.createElement(AreaCountComponent, {
            key: componentKey,
            visible: cat ? rot.visible && cat.visible : rot.visible,
            antall: s.antall,
            omrade: s.omrade,
            colorString,
            vegobjektTypeId: rot.typeId,
        });
    };

    const areaCount = (
        rot: VegobjekttypeStateWithAreaResult,
        statistics: VegobjekterStatistic[]
    ) => {
        return statistics
            .filter(
                (s): s is VegobjekterStatisticWithOmrade => s.antall > 0 && hasOmrade(s)
            )
            .map(s => {
                const colorString = rot.color ? resolveColor(rot.color) : defaultColor;
                return areaCountElement(rot, s, colorString);
            });
    };
    return (
        <>
            {roadObjectTypes
                .filter(hasAreaStatistics)
                .map(featureType =>
                    areaCount(featureType, featureType.result.areaStatistics)
                )}
        </>
    );
};
